import Vue from 'vue';
import Component from 'vue-class-component';
import SidebarComponent from '@/components/sidebar/sidebar.component.vue';
import HeaderComponent from '@/components/header/header.component.vue';
import LoaderComponent from '@/components/loader/loader.component.vue';
import ModalPermissionsComponent from '@/components/modal-permissions/modal-permissions.component.vue';
import ModalLoginComponent from '@/components/modal-login/modal-login.component.vue';

import QuestionService from '@/core/services/question.service.ts';
import SidebarService from '@/core/services/sidebar.service.ts';

@Component({
  components: {
    SidebarComponent,
    HeaderComponent,
    ModalPermissionsComponent,
    ModalLoginComponent,
    LoaderComponent
  }
})
export default class CreateQuestionsComponent extends Vue {

  questionService: any = new QuestionService();
  sidebarService: any = new SidebarService();
  isLoading: boolean = false;
  logInModal: boolean = false;
  showModal: boolean = false;
  isSuccess: boolean = false;
  isErrorServer: boolean = false;
  modal: boolean = false;
  error: boolean = false;
  genericErr: any = [];
  surveyList: any = [];
  sectionList: any = [];
  skillList: any = [];
  question: string = "";
  survey: string = "";
  section: string = "";
  skill: string = "";
  skillOne: string = "";
  skillTwo: string = "";
  skillThree: string = "";
  skillFour: string = "";
  optionOne: any = {};
  optionTwo: any = {};
  optionThree: any = {};
  optionFour: any = {};
  options: any = [];
  title: string = "";
  skill: any = "default";
  section: any = "default";
  survey: any = "default";

  mounted (){
    const _ = this;
    _.getSurveys();
    _.getSection();
    _.getSkill();
  }

  closeSidebar(){
    const _ = this;
    _.sidebarService.close();
  }

  getSurveys(){
    const _ = this;
    _.isLoading = true;
    _.questionService.getSurveys().then((data: any) => {
      _.surveyList = data['data'].surveys;
      setTimeout(() => {
        _.isLoading = false;
      }, 1500)
    })
    .catch((err: any) => {
      if(err.response.data.message.includes('Invalid or inexistent user')){
        localStorage.removeItem('tk_auth');
        _.logInModal = true;
      }
      _.isLoading = false;
    })
  }

  getSection(){
    const _ = this;
    _.isLoading = true;
    _.questionService.getSection().then((data: any) => {
      _.sectionList = data['data'].sections;
      setTimeout(() => {
        _.isLoading = false;
      }, 1500)
    })
    .catch((err: any) => {
      _.isLoading = false;
    })
  }

  getSkill(){
    const _ = this;
    _.isLoading = true;
    _.questionService.getSkill().then((data: any) => {
      _.skillList = data['data'].skills;
      console.log(data);
      setTimeout(() => {
        _.isLoading = false;
      }, 1500)
    })
    .catch((err: any) => {
      _.isLoading = false;
    })
  }

  create(){
    const _ = this;
    let question = {
      question: _.question,
      idSurvey: _.survey,
      idSection: _.section,
      idSkill: _.skill,
      options: [
        _.optionOne,
        _.optionTwo,
        _.optionThree,
        _.optionFour
      ]
    };
    console.log(question);
    _.isLoading = true;
    _.questionService.create(question).then((data: any) => {
      console.log(data);
      _.isSuccess = true;
      _.isErrorServer = false;
      _.error = false;
      _.modal = true;
      setTimeout(() => {
        _.isLoading = false;
        _.$router.push('/questions');
      }, 2000)
    })
    .catch((err: any) => {
      _.modal = true;
      _.error = true;
      _.isErrorServer = true;
      setTimeout(() => {
        _.isLoading = false;
      }, 2000)
    })
  }

  validations(question = ''){
    const _ = this;
    _.genericErr = [];
    if(question == ''){
      _.genericErr.push("Por favor escribe una pregunta");
    }
    if(_.survey == ''){
      _.genericErr.push("Por favor selecciona una encuesta");
    }
    if(_.genericErr.length > 0){
      _.modal = true;
      _.error = true;
      return;
    }
    _.create()
  }
}
